import React from 'react';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import {
  withStyles,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  ClickAwayListener,
  Box,
  Typography,
  withWidth,
  isWidthUp,
} from '@material-ui/core';
import { observer } from 'mobx-react';

import { FormField2 } from 'components';
import { twoOrMoreDecimals, highlightText } from 'utils/helpers';

import styles from './styles';

class NormSearchContainer extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      search: props.initialSearchString || null,
      showResults: false,
      selectedCode: null,
    }
    
    this.handleSearch = _.debounce(this.handleSearch, 1000);
  }

  componentDidMount() {
    if(this.props.initialSearchString) this.handleSearch(this.props.initialSearchString);
  }

  componentWillUnmount() {
    this.props.store.setResults([]);
  }

  handleSearch = (value, version) => {
    if (value.length < 1) {
      // Do not search if less than one char
      this.props.store.setResults([]);
      this.setState({
        showResults: false,
      });
      return;
    }

    this.props.store.search(value, version, this.props.type);
    this.setState({
      showResults: true,
      selectedCode: null,
    });
  };

  onSearchChange({ value }) {
    this.setState({
      search: value,
    });

    this.handleSearch(value);
  }

  onSearchFocus() {
    if (this.props.store.results.length) {
      this.setState({ showResults: true });
    }
  }

  handleSelect(item) {
    const { onSelect } =  this.props;

    if (onSelect) {
      onSelect(item);
    }

    this.setState({
      showResults: false,
      selectedCode: item.code,
    });
  }
  
  onClickAway() {
    this.setState({ showResults: false });
  }

  renderResults() {
    const { classes, store, width, t } = this.props;

    if (!this.state.showResults || (this.state.showResults && !this.state.search)) {
      return null;
    }

    return (
      <Box boxShadow={3} className={classes.results} style={{ width: isWidthUp('sm', width) ? 'auto' : '100%' }}>
        <div className={classes.resultsWrap}>
          <div className={classes.resultHeadersWrap}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: '10%' }}>{t('Rinkinys')}</TableCell>
                  <TableCell style={{ width: '15%' }}>{t('Kodas')}</TableCell>
                  <TableCell style={{ width: '15%' }}>{t('Mato vnt.')}</TableCell>
                  <TableCell style={{ width: '15%' }}>{t('Darbo sąnaudos')}</TableCell>
                  <TableCell style={{ width: '45%' }}>{t('Komplekso/darbo pavadinimas')}</TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </div>

          <div className={classes.resultListWrap}>
            <Table size="small">
              <TableBody>
                {store.results?.length ? _.map(store.results, item => (
                  <TableRow
                    className={classes.pointer}
                    key={item.rootCode + item.code}
                    onClick={() => this.handleSelect({ ...item })}
                    selected={item.code === this.state.selectedCode}
                    hover
                  >
                    <TableCell style={{ width: '10%' }}>{item.rootCode}</TableCell>
                    <TableCell style={{ width: '15%' }}>{highlightText(item.code, this.state.search)}</TableCell>
                    <TableCell style={{ width: '15%' }}>{item.unit}</TableCell>
                    <TableCell style={{ width: '15%' }}>{twoOrMoreDecimals(item.laborCosts)}</TableCell>
                    <TableCell style={{ width: '45%' }}>{highlightText(item.title, this.state.search)}</TableCell>
                  </TableRow>
                )) : (
                  <TableRow>
                    <TableCell colSpan={5}>
                      <Typography variant="h5" className={classes.noResults}>
                        {store.isSearching ? `${t('Ieškoma')}...` : t('Rezultatų nerasta')}
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </div>
      </Box>
    )
  }

  render() {
    const { classes, className, style, inputStyle, t } = this.props;

    return (
      <ClickAwayListener onClickAway={this.onClickAway.bind(this)}>
        <div
          className={[classes.root, className].join(' ')}
          styles={style}
        >
          <FormField2
            className={classes.input}
            type="text"
            name="search"
            placeholder={`${t('Paieška pagal tekstą')}...`}
            onChange={this.onSearchChange.bind(this)}
            onFocus={this.onSearchFocus.bind(this)}
            value={this.state.search}
            style={inputStyle}
          />
          <span className={classes.icon}/>

          {this.renderResults()}
        </div>
      </ClickAwayListener>
    )
  }
}

export default compose(withStyles(styles), withWidth(), withTranslation())(observer(NormSearchContainer));